<template>
    <v-autocomplete
        v-on="$listeners"
        v-bind="computedProps"
        v-disabled-icon-focus
        :required="required"
        :class="showRequiredFieldLine ? 'cls-required-field' : undefined"
    >
        <!-- Dynamically inherit slots from parent -->
        <template v-for="(slot, name) in $scopedSlots" v-slot:[name]="item">
            <slot :name="name" v-bind="item"></slot>
        </template>
        <!-- make all slots from v-autocomplete reusable from parent -->
        <template v-for="(_, slot) in $slots">
            <template :slot="slot">
                <slot :name="slot"></slot>
            </template>
        </template>
    </v-autocomplete>
</template>
<script>
import mixinWField from "@/mixins/w-field";
export default {
    name: "BaseAutocomplete",
    mixins: [mixinWField],
    computed: {
        computedProps() {
            return {
                ...this.$props,
                ...this.$attrs,
                filled: true
            };
        }
    }
};
</script>
